// extracted by mini-css-extract-plugin
export var locationCard = "_fe-0";